//#region IMPORT
import React, { useEffect, useState } from 'react';
import M_FILE_BASIC_01 from './M_FILE_BASIC_01';
import Global from '../../../../Services/Common/Global';

import { useDispatch, useSelector } from 'react-redux';
import { CommonActions } from '../../../../Reducer/CommonReducer';
import { useSearch1 } from './M_FILE_BASIC_01_Query';
import { useAppNavigate } from '../../../../Hooks/back/useAppNavigate';
//#endregion

function M_FILE_BASIC_01F(props) {
  //#region 변수
  const dispatch = useDispatch();
  const activeStep = useSelector((state) => state.common.activeStep);
  const [loading, setLoading] = useState(false);
  const [fullUrl, setFullUrl] = useState();
  const [renderPreview, setRenderPreview] = useState(null);
  const [numPages, setNumPages] = useState();
  const [pageNumber, setPageNumber] = useState(1);
  const [pdfFile, setPdfFile] = useState();
  const [pageWidth, setPageWidth] = useState(window.innerWidth * 1);
  const [pageViewHeight, setPageViewHeight] = useState(0);
  const { navigate } = useAppNavigate();
  //#endregion

  //#region 이벤트
  useEffect(() => {
    const handleResize = () => {
      setPageWidth(window.innerWidth * 1);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    if (loading) {
      setLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageNumber]);
  //#endregion

  //#region 쿼리
  useSearch1({
    onSuccess: async (rows) => {
      const first = rows[0];
      const path = first?.eduLocation ?? first?.EDU_LOCATION;
      if (!path) {
        setPdfFile(null);
        setFullUrl(null);
        setRenderPreview(null);
        return;
      }

      const ext = path.split('.').pop()?.toLowerCase();
      let finalPath = path;
      if (['hwp', 'doc', 'docx', 'ppt', 'pptx', 'xls', 'xlsx'].includes(ext)) {
        finalPath = path.replace(/\.[^/.]+$/, '.pdf');
      }

      const fileUrl = `${Global.file.useUrl}files/${finalPath}`;
      setPdfFile(finalPath);
      setFullUrl(fileUrl);
      // URL 직접 전달 - react-pdf가 Range 요청으로 스트리밍 처리
      setRenderPreview(fileUrl);
    },
  });
  //#endregion

  //#region 나머지 함수
  const getExtensionFromUrl = (url = '') => {
    const parts = url?.split('.');
    return parts?.length > 1 ? parts.pop().toLowerCase() : '';
  };

  const onDocumentLoadSuccess = ({ numPages: total }) => {
    setNumPages(total);
  };

  const goToPrevPage = () => {
    if (pageNumber > 1) {
      setLoading(true);
      setPageNumber(pageNumber - 1);
    } else {
      navigate('/Home');
    }
  };

  const goToNextPage = () => {
    if (pageNumber < numPages) {
      setLoading(true);
      setPageNumber(pageNumber + 1);
    }
  };

  //#endregion

  return (
    <M_FILE_BASIC_01
      pdfFile={pdfFile}
      loading={loading}
      setLoading={setLoading}
      onDocumentLoadSuccess={onDocumentLoadSuccess}
      pageNumber={pageNumber}
      pageWidth={pageWidth}
      numPages={numPages}
      activeStep={activeStep}
      setActiveStep={(step) => dispatch(CommonActions.setActiveStep(step))}
      renderPreview={renderPreview}
      fullUrl={fullUrl}
      getExtensionFromUrl={getExtensionFromUrl}
      pageViewHeight={pageViewHeight}
      setPageViewHeight={setPageViewHeight}
      goToPrevPage={goToPrevPage}
      goToNextPage={goToNextPage}
    />
  );
}

export default M_FILE_BASIC_01F;
